import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const programmeCollaborationRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/programme-collaboration",
  component: lazyRouteComponent(
    () => import("@l30/web-programme/pages/programme-collaboration.page"),
    "ProgrammeCollaborationPage",
  ),
});
